import {Component, Inject, OnInit} from '@angular/core';
import {MdDialog, MdDialogRef, MD_DIALOG_DATA} from '@angular/material';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AppMessages } from '../../shared/constants/messages';
import {PatientWarningService} from '../../components/dialog/patient-warning.service';

@Component({
  selector: 'app-dialog-warning',
  templateUrl: './patient-warning.component.html'
  
})
export class PatientWarningComponent implements OnInit {
  public title: string = AppMessages.dialog.successTitle;
  public message: string = '';  
  public patientRef: string = '';

  public yesOption = false;
  public primaryButtons = AppMessages.dialog.closeButton;
  constructor(
    public dialogRef:MdDialogRef<PatientWarningComponent>,
              private router: Router,                  
              @Inject(MD_DIALOG_DATA) public data:any) {   

}

  ngOnInit() {    
    this.generateDialog();
  }

  generateDialog() {    
    this.message = this.data["message"] || this.message;
    this.patientRef = this.data["patientRef"] || this.patientRef;
    this.primaryButtons = this.data["primaryButtons"] || AppMessages.dialog.closeButton;   
    this.patientRef= this.data["Ref"];        
  }

  onClickPatientDetail(){
    //Navigate to Detail patient page 
    this.router.navigate(['/consultation/result-search-patient?reference=' + this.patientRef])
  }

  onCloseDialog(){
    this.yesOption = true;
    this.dialogRef.close(this.yesOption);
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/components/dialog/patient-warning.component.ts